import React from 'react';
import { Form } from 'antd';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.css';

export function FieldWrap({ name, hasError, error, children }) {
  const { t } = useTranslation();

  return (
    <div>
      <span className={styles.label}>{t(`field.${name}.label`)}</span>
      <Form.Item
        hasFeedback={hasError}
        help={hasError ? t(`error.${error}`) : false}
        validateStatus={hasError ? 'error' : 'success'}
      >
        {children}
      </Form.Item>
    </div>
  );
}
